module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.change
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [(_vm.isWinter) ? _c('h2', [_vm._v(_vm._s(_vm.$t('texts.texts-skischool-header-top-title')))]) : _vm._e(), _vm._v(" "), (_vm.isSummer) ? _c('h2', [_vm._v("Välj vilken cykelskola som passar dig bäst")]) : _vm._e(), _vm._v(" "), (!_vm.isSummer) ? _c('div', {
    class: {
      disabled: _vm.loading, notification: true, 'notification--transparent': true
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('texts.texts-skischool-header-title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('texts.texts-skischool-header-text')))])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('OutlineButton', {
    staticClass: "max-mobile",
    class: {
      active: _vm.expanded
    },
    attrs: {
      "label": _vm.$t('skischool.more-filters'),
      "closeLabel": _vm.$t('skischool.close-filters'),
      "icon": "Filter",
      "iconscale": 1.5,
      "status": _vm.expanded
    },
    on: {
      "clicked": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  })], 1), _vm._v(" "), _c('SkiSchoolFilter', {
    class: {
      disabled: _vm.loading, filter: true, opened: _vm.expanded
    },
    attrs: {
      "season": _vm.isSummer ? 'summer' : 'winter'
    },
    on: {
      "change": _vm.change
    }
  }), _vm._v(" "), _c('SkiSchoolFilterInfo', {
    attrs: {
      "count": _vm.count
    },
    on: {
      "change": _vm.change
    }
  })], 1), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading,
      "text": _vm.$t('skischool.applying-filters')
    }
  }), _vm._v(" "), _c('SkiSchoolList', {
    class: {
      disabled: _vm.loading
    },
    attrs: {
      "data": _vm.data,
      "count": _vm.count
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dc30a0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiSchool/SkiSchoolOverview.vue
// module id = 965
// module chunks = 0